module.exports = __webpack_public_path__ + "static/laezel-mtg_clb-e0c669f302ee550802a7bd894c946efe.jpg";